var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalDetailActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H19M15 12H19M17 16H19M17 21H7C3 21 2 20 2 16V8C2 4 3 3 7 3H17C21 3 22 4 22 8V16C22 20 21 21 17 21Z",
    stroke: "#FCEE21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.3299C11.9327 15.628 11.6219 14.9717 11.1214 14.4749C10.621 13.9781 9.96243 13.6721 9.26 13.6099C8.75457 13.5599 8.24543 13.5599 7.74 13.6099C7.03826 13.674 6.38078 13.9806 5.88069 14.477C5.3806 14.9735 5.06918 15.6287 5 16.3299M8.5 11.2899C8.98004 11.2899 9.44042 11.0992 9.77986 10.7598C10.1193 10.4203 10.31 9.95996 10.31 9.47992C10.31 8.99988 10.1193 8.5395 9.77986 8.20006C9.44042 7.86062 8.98004 7.66992 8.5 7.66992C8.01996 7.66992 7.55958 7.86062 7.22014 8.20006C6.8807 8.5395 6.69 8.99988 6.69 9.47992C6.69 9.95996 6.8807 10.4203 7.22014 10.7598C7.55958 11.0992 8.01996 11.2899 8.5 11.2899Z",
    stroke: "#FCEE21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetailActiveIcon);
export default __webpack_public_path__ + "static/media/personal-detail-active-icon.456f78f3b24e979bed28aa3bfd94090b.svg";
export { ForwardRef as ReactComponent };